import { render, staticRenderFns } from "./EditProfileOverlay.vue?vue&type=template&id=1b85555c&"
import script from "./EditProfileOverlay.vue?vue&type=script&lang=js&"
export * from "./EditProfileOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports